webpackJsonp([199081029669686],{

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lokki-289x217-2463.2468774c.jpg";

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 0 ', ';\n'], ['\n  margin: 0 ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(34);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _typography = __webpack_require__(21);
	
	var _layouts = __webpack_require__(20);
	
	var _SideBarRight = __webpack_require__(58);
	
	var _SideBarRight2 = _interopRequireDefault(_SideBarRight);
	
	var _gallery = __webpack_require__(68);
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	var _lokki289x = __webpack_require__(191);
	
	var _lokki289x2 = _interopRequireDefault(_lokki289x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Col22 = _layouts.Col2.extend(_templateObject, (0, _typography.rhythm)(0.25));
	
	var Hinnasto = function (_React$Component) {
	  _inherits(Hinnasto, _React$Component);
	
	  function Hinnasto() {
	    _classCallCheck(this, Hinnasto);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Hinnasto.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Kirsti Louko - Hinnasto'
	        )
	      ),
	      _react2.default.createElement(
	        _layouts.PageTop,
	        null,
	        _react2.default.createElement(
	          _layouts.TitleH1,
	          null,
	          'HINNASTO'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Minulla on Kelan kanssa valtakirjasopimus, joka oikeuttaa perim\xE4\xE4n asiakkaalta hoidon omavastuuosuuden ja hakemaan asiakkaan puolesta korvauksen.'
	        )
	      ),
	      _react2.default.createElement(
	        _layouts.Content,
	        null,
	        _react2.default.createElement(_SideBarRight2.default, { view: 'hinnasto' }),
	        _react2.default.createElement(
	          _layouts.Main,
	          null,
	          _react2.default.createElement(
	            Col22,
	            null,
	            _react2.default.createElement(
	              _layouts.InfoBlock,
	              { full: true },
	              _react2.default.createElement(
	                _layouts.Title,
	                { small: true },
	                'PSYKOTERAPIA'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'content-info' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Yksil\xF6psykoterapiak\xE4ynti'
	                  ),
	                  _react2.default.createElement('br', null),
	                  'Kesto: 45min ',
	                  _react2.default.createElement('br', null),
	                  'Hinta: 80\u20AC ',
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Lis\xE4tiedot'
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'KELA korvaa l\xE4\xE4k\xE4rin l\xE4hetteell\xE4 16-67-vuotiaille kuntoutuspsykoterapiasta 57,60\u20AC kerralta.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/psykoterapia' },
	                    'Katso esittely'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _layouts.InfoBlock,
	              { full: true },
	              _react2.default.createElement('img', { src: _lokki289x2.default })
	            )
	          ),
	          _react2.default.createElement(
	            Col22,
	            null,
	            _react2.default.createElement(
	              _layouts.InfoBlock,
	              { full: true },
	              _react2.default.createElement(
	                _layouts.Title,
	                { small: true },
	                'TY\xD6NOHJAUS'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'content-info' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Hinnat sovitaan asiakkaan kanssa toimeksiannon laajuudesta riippuen.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/tyonohjaus' },
	                    'Katso esittely'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Hinnasto;
	}(_react2.default.Component);
	
	exports.default = Hinnasto;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hinnasto-js-336e54669e8a666bc8a9.js